// Right Chat - regras puras da tela do Kanban (ordenacao, move otimista, erro).
//
// Separado do composable de proposito: sem `import { ref } from 'vue'` aqui, este modulo
// roda em Node puro e da para testar offline, sem o node_modules do Chatwoot. Ver
// scripts/testes-kanban-ui.mjs.

export const byPosition = (a, b) => {
  const positionA = Number.isFinite(a.position) ? a.position : 0;
  const positionB = Number.isFinite(b.position) ? b.position : 0;
  return positionA === positionB ? a.id - b.id : positionA - positionB;
};

export const sortTasks = tasks => [...tasks].sort(byPosition);

export const tasksForStep = (tasks, stepId) =>
  sortTasks(tasks.filter(task => task.board_step_id === stepId));

// Reordena a coluna de destino como o servidor vai reordenar, para a tela nao piscar
// entre o drop e a resposta. Nao muta a lista recebida: o array original e o snapshot
// usado no rollback quando o servidor recusa o move.
export const applyOptimisticMove = (
  tasks,
  { taskId, toStepId, insertBeforeTaskId = null }
) => {
  const next = tasks.map(task => ({ ...task }));
  const moved = next.find(task => task.id === taskId);
  if (!moved) return next;

  const target = next
    .filter(task => task.board_step_id === toStepId && task.id !== taskId)
    .sort(byPosition);

  const foundIndex =
    insertBeforeTaskId === null || insertBeforeTaskId === undefined
      ? -1
      : target.findIndex(task => task.id === insertBeforeTaskId);
  // Card de referencia sumiu (outro agente moveu antes): cai no fim da coluna, que e o
  // mesmo que o servidor faz quando nao acha o `insert_before_task_id`.
  const index = foundIndex === -1 ? target.length : foundIndex;

  moved.board_step_id = toStepId;
  target.splice(index, 0, moved);
  target.forEach((task, position) => {
    task.position = position;
  });

  return next;
};

// O backend responde erro em `{ error, errors }`. Sem esse desempacotamento a tela
// mostraria "Request failed with status code 422", que nao ajuda ninguem.
export const errorMessage = err => {
  const data = err?.response?.data;
  if (data?.error) return data.error;
  if (data?.errors) {
    const messages = Object.entries(data.errors).map(
      ([field, list]) => `${field}: ${[].concat(list).join(', ')}`
    );
    if (messages.length) return messages.join(' | ');
  }
  if (err?.response?.status === 404) return 'Registro nao encontrado.';
  return err?.message || 'Erro inesperado.';
};
